/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsDimensionCostCenterAccount {
    getFixupPrototypeFunction() { return FilterOptionsDimensionCostCenterAccount.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsDimensionCostCenterAccount>): FilterOptionsDimensionCostCenterAccount {
        let obj = Object.assign(new FilterOptionsDimensionCostCenterAccount(), model);
        FilterOptionsDimensionCostCenterAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsDimensionCostCenterAccount>): FilterOptionsDimensionCostCenterAccount {
        if (!model) return null;
        return FilterOptionsDimensionCostCenterAccount.newInstance(<FilterOptionsDimensionCostCenterAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsDimensionCostCenterAccount) {
        if (!obj) return;

        models.FilterOptionsDimensionCostCenterAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsDimensionCostCenterAccount): boolean {
        Object.setPrototypeOf(obj, FilterOptionsDimensionCostCenterAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates the status of the cloud account in corestack
     */
    status: models.ServiceAccountStatus;

    /**
     * ID of the account
     */
    service_account_id: string;

    /**
     * Name of the account
     */
    service_account_name: string;

    /**
     * Currency for the account
     */
    currency: models.Currency;

    /**
     * Scope of the account
     */
    scope: models.ServiceAccountScope;

}
